import { IconSnowflake, IconSun } from "@octopus-energy/icons"
import { useTranslations } from "next-intl"
import { type OffPeakValue } from "../../types/offPeakValues"
import { formatOffPeakHours } from "../../utils/formatOffPeakHours"

const DEFAULT_ICON_SIZE = 20

const LOW_SEASON = {
    icon: {
        component: IconSun,
        color: "yellow",
    },
    variant: "summer",
}

const HIGH_SEASON = {
    icon: {
        component: IconSnowflake,
        color: "cyan",
    },
    variant: "winter",
}

// Somehow the season codes have changed over time, so we need to account for both the current and old production data.
const CONFIG = {
    // Production Data
    SAISON_BASSE: LOW_SEASON,
    SAISON_HAUTE: HIGH_SEASON,
    // Old Production Data
    BASSE_SAISON: LOW_SEASON,
    HAUTE_SAISON: HIGH_SEASON,
} as const

function isValidSeasonCode(seasonCode: string): seasonCode is keyof typeof CONFIG {
    return seasonCode in CONFIG
}

type MeterPointOffPeakSeasonProps = {
    offPeakValue: OffPeakValue
    size?: number
}

export function MeterPointOffPeakSeason({
    offPeakValue,
    size = DEFAULT_ICON_SIZE,
}: MeterPointOffPeakSeasonProps) {
    const t = useTranslations("MeterPointOffPeakSeason")

    const { label, season } = offPeakValue

    if (!isValidSeasonCode(season.code)) {
        return null
    }

    const {
        icon: { component: Icon, color },
        variant,
    } = CONFIG[season.code]

    return (
        <>
            <Icon
                color={color}
                size={size}
                verticalAlign="sub"
            />
            &nbsp;
            <b>{t("seasonalVariant", { variant })}</b>&nbsp;: {formatOffPeakHours(label)}
        </>
    )
}

MeterPointOffPeakSeason.messages = ["MeterPointOffPeakSeason"] as const
